import { CreativeListDataProvider } from './CreativeListDataProvider';
import {
  CreativeListCommonColumns,
  commonColumnSetting,
  getCommonColumnData,
  getColumnSetting
} from './CreativeListCommonColumnData';
import { renderColumn } from 'components/TableColumn/TableColumn';
import { getCreativeListFormatters } from './CreativeListFormatters';
import { CreativeListRecord, OutdoorType } from 'core/creative/Creative';
import _ from 'lodash';

enum COLUMNS {
  OUTDOOR_TYPE = 'outdoorType',
  DURATION = 'duration'
}

export class OutdoorCreativeListDataProvider implements CreativeListDataProvider {
  protected formatters: any;
  constructor(model) {
    this.formatters = getCreativeListFormatters(model);
  }

  getColumns() {
    return [
      renderColumn(
        commonColumnSetting[CreativeListCommonColumns.NAME_ID],
        this.formatters.nameIdFormatter,
        this.formatters.nameIdHeaderFormatter
      ),
      renderColumn(
        commonColumnSetting[CreativeListCommonColumns.STATUS],
        this.formatters.stateFormatter
      ),
      renderColumn(
        commonColumnSetting[CreativeListCommonColumns.PREVIEW],
        this.formatters.previewFormatter
      ),
      renderColumn(
        getColumnSetting(COLUMNS.OUTDOOR_TYPE),
        this.formatters.outdoorTypeFormatter
      ),
      renderColumn(
        getColumnSetting(COLUMNS.DURATION),
        this.formatters.durationFormatter
      ),
      renderColumn(
        commonColumnSetting[CreativeListCommonColumns.LIMITATION],
        this.formatters.limitationFormatter
      ),
      renderColumn(
        commonColumnSetting[CreativeListCommonColumns.EDITBTNS],
        this.formatters.floatingEditBtnsFormatter
      )
    ];
  }

  getViewModel(creative: CreativeListRecord) {
    const outdoorType = _.get(creative, 'outdoorType', OutdoorType.VIDEO);
    const duration = _.get(creative, 'duration', 30);
    return {
      ...getCommonColumnData(creative),
      [COLUMNS.OUTDOOR_TYPE]: outdoorType,
      [COLUMNS.DURATION]: duration
    };
  }
}
